import React, { cloneElement, isValidElement, ReactNode, useEffect, useRef, useState } from 'react';
import { LoadingArea } from './LoadingArea';
import { SpinnerContainer } from './SpinnerContainer';
import useClickOutsideRef from '../hooks/useClickOutsideRef';

type PopupProps = {
  customContent?: ReactNode;
  message?: string;
  loading?: boolean;
  subText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const Popup: React.FC<PopupProps> = ({ message, subText, loading, onConfirm, onCancel, customContent }) => {

  return (

    <div className="fixed inset-0 flex items-center justify-center text-left bg-gray-800 bg-opacity-50 z-50">
      <SpinnerContainer show={!!loading}>
        {customContent ? customContent :
        <div className="bg-white rounded-lg shadow-lg p-6 w-80">
          
            <><p className="text-gray-800 text-lg font-semibold mb-4">{message}</p>
              {subText &&
                <p className="text-gray-800 text-sm mb-4">{subText}</p>
              }
              <div className="flex justify-end gap-3">
                <button
                  className="bg-primary hover:bg-primary_darker text-white px-6 py-2 rounded-xl transition"
                  onClick={onConfirm}
                >
                  Jah
                </button>
                <button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-2 rounded-xl transition"
                  onClick={onCancel}
                >
                  Ei
                </button>
              </div></>
          

        </div>}
      </SpinnerContainer>
    </div>



  );
};

export default Popup;
